//  ====================================================================================================================
//  TABLE OF CONTENTS
//  ====================================================================================================================

window.noZensmooth = true
import zenscroll from 'zenscroll';

/** 
* Mobile checker
*
* @param {number} winWidth
* @return {boolean} bool
*/
window.contentsMobile = function (winWidth) {
    if (winWidth <= 800) {
        return true;
    } else {
        return false;
    }
};

/**  
* Add horizontal line to H2
*
*/
window.doHorizontalBreak = function () {

    document.querySelectorAll('.post-content-inner h2, .text-area-inner h2, .panelists h2').forEach((heading) => {

        let headingTag = heading;
        let tagName = headingTag.tagName;

        //  Add the horizontal line
        if (tagName === 'H2' || tagName === 'h2') {

            let div = document.createElement('div');

            div.className = 'content-gap';
            div.innerText = '';
            headingTag.appendChild(div);

            heading.classList.add('anchor-heading-h2');

        } else {
            heading.classList.add('anchor-heading');
        }
    });

    // Remove the heading classes
    document.querySelectorAll('.post-content-inner .panel .headings h2, .post-content-inner .panel h2').forEach((panelHeading) => {
        let headingTag = panelHeading;
        headingTag.removeAttribute('class');
    });

    // Listings widget fix
    document.querySelectorAll('.post-content-inner .ls-widget .content .form .col1 .text-block h2').forEach((listingScanner) => {
        listingScanner.removeAttribute('class');

        if (listingScanner.querySelector('.content-gap')) {
            listingScanner.querySelector('.content-gap').remove();
        }
    });

    // Remove the panel id
    document.querySelectorAll('.post-content-inner .panel').forEach((panel) => {
        panel.removeAttribute('id');
    });

    document.querySelectorAll('.post-content-inner .bl-popout-box-green, .post-content-inner .bl-popout-box-white, .post-content-inner .bl-popout-box-gray').forEach((popOutBox) => {
        popOutBox.removeAttribute('id');

        if (popOutBox.querySelector('.content-gap')) {
            popOutBox.querySelector('.content-gap').remove();
        }
    });
};

/** 
* Remove Emojis
*
* @param {string} string
* @return {string} string
*/
window.removeEmojis = function (string) {
    var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    string = string.replace(regex, '');
    string = string.trim();
    return string;
};

/** 
* Strip html tags from the headings
*
* @return {string} str
*/

window.stripHTML = function () {

    let str = document.querySelector('.post-content-inner');
    let headingUnique = [];

    // Remove unwanted HTML from heading tags
    document.querySelectorAll(['.post-content-inner h1, .post-content-inner h2, .post-content-inner h3, .post-content-inner h4, .post-content-inner .panel .headings h2']).forEach((heading) => {

        heading.removeAttribute('class');
        heading.removeAttribute('id');

        if (heading.querySelector(".bl-unique")) {
            unique = heading.querySelector(".bl-unique").innerText;
            uniqueDashed = unique.replace(/\s+/g, '-').toLowerCase();
            headingUnique.push(uniqueDashed);
        } else {
            headingUnique.push(null);
        }

        let headingHTML = heading.innerHTML;

        let headingInnerHTML = headingHTML.replace(/<(span)\b.*?class=(['"\s]?)bl-unique\2.*?>.*?<\/\1>/gi, '')
            .replace(/<[^>]*>?/gm, '')
            .replace(/<\/?span[^>]*>/g, "")
            .replace(/\&nbsp;/g, ' ')
            .trim();
        heading.innerHTML = headingInnerHTML;

    });

    //  Output the HTML for processing
    str = document.querySelector('.post-content-inner');

    if (str) {
        str = str.innerHTML;
        return [str, headingUnique];
    }
};

/**
 * Check for window resize and reposition the contents
 */
function resizeComplete() {
    window.positionContents();
}

let doit = null;
window.onResize = function () {
    clearTimeout(doit);
    doit = setTimeout(resizeComplete, 0);
};
window.addEventListener('resize', onResize);

/**
 * Position the table of contents correctly
 */
window.positionContents = function () {

    let isMobileDevice = window.contentsMobile(window.innerWidth);

    //  get the header height
    let headerHeight = document.getElementById('nav-container').clientHeight;
    let promotionBarHeight = document.getElementById('promotion-bar');

    if (promotionBarHeight) {
        promotionBarHeight = promotionBarHeight.clientHeight;
        headerHeight = headerHeight + promotionBarHeight;
    }

    //  Add the header height to the sticky margin
    if (isMobileDevice) {
        let pageMargin = document.querySelector('.post-margin');

        if (pageMargin) {
            pageMargin.style.top = headerHeight - 38 + 'px';
        }

    } else {
        let pageMargin = document.querySelector('.post-margin');

        if (pageMargin) {
            pageMargin.style.top = headerHeight + 26 + 'px';
        }
    }
};

/**
 * Gets all the headings in the page and creates a table of contents from them
 *
 * @param {element} tocContainer
 * @param {element} tocOutput
 */
window.tableOfContentsConstruct = function (tocContainer, tocOutput) {

    let isMobileDevice;
    let toc = "";
    let tocSel = "";
    let level = 0;
    let killAnchor = false;

    tocContainer = document.querySelector(tocContainer) || document.querySelector('.post-content-inner');
    tocOutput = tocOutput || '#toc';

    //  Clean up the headings ready for conversion
    let stripHTML = window.stripHTML();

    let convertedString = stripHTML[0];
    let unique = stripHTML[1];

    isMobileDevice = window.contentsMobile(window.innerWidth);

    window.positionContents();
    let titleArr = [];
    let count = 0;

    if (tocContainer) {
        tocContainer.innerHTML =
            convertedString.replace(
                /<h([\d])>([^<]+)<\/h([\d])>/gi,
                function (str, openLevel, titleText, closeLevel) {

                    //  Do a load of parsing on the titles
                    //  and clean them up so they are good for anchor tags

                    var anchor = titleText.toLowerCase()
                        .trim()
                        .replace(/[`~@#%^*&_|+\-='",<>\{\}\[\]\\\/]/gi, '')
                        .replace(/[?!();:]/g, '')
                        .replace(/\&nbsp;/g, '')
                        .replace(/amp/g, '')
                        .replace(/["|'|’|‘|’|“|”|(|)|/]/g, "")
                        .replace(/\./g, '')
                        .replace(/(&nbsp;|<([^>]+)>)/ig)
                        .replace(/^-*|-*$|(-)-*/g, "")
                        .replace(/ +/g, '-');


                    //  get rid of emojis
                    anchor = window.removeEmojis(anchor);

                    // if there is the unique class then add it
                    if (unique[count] != null) {
                        anchor = anchor + '-' + unique[count];
                    }

                    //  Remove initial numbers = there is definitely a better way of doing this !!
                    if (!isNaN(anchor.charAt(0))) {
                        anchor = anchor.substring(1);
                        if (!isNaN(anchor.charAt(0))) {
                            anchor = anchor.substring(1);
                            if (!isNaN(anchor.charAt(0))) {
                                anchor = anchor.substring(1);
                            }
                        }
                    }

                    if (anchor.startsWith('-')) {
                        anchor = anchor.replace('-', '');
                    }

                    if (openLevel != closeLevel) {
                        return str;
                    }

                    if (openLevel > level) {
                        toc += (new Array(openLevel - level + 1)).join('<ul>');
                    } else if (openLevel < level) {
                        toc += (new Array(level - openLevel + 1)).join('</li></ul>');
                    } else {
                        toc += (new Array(level + 1)).join('</li>');
                    }

                    level = parseInt(openLevel);

                    if (anchor === 'local-listings-health-scanner') {
                        anchor = 'local-listing-health-scanner';
                    }

                    if (killAnchor === false && anchor !== 'local-listings-health-scanner') {
                        toc += '<li class="bl-toc-list"><div class="toc-link-acc"><a class="bl-toc-link" href="#' + anchor + '">' + titleText + '</a><div class="open"></div></div>';
                        tocSel += '<option value="' + anchor + '" class="' + anchor + '">';
                    }

                    if (level && level > 2) {
                        tocSel += '- &nbsp;' + titleText + "</option>";
                    } else {
                        tocSel += titleText + "</option>";
                    }

                    count++;

                    return '<h' + openLevel + ' id="' + anchor + '">' + titleText + '</h' + closeLevel + '>';
                }
            );

        if (level) {
            toc += (new Array(level + 1)).join('</ul>');
        }

        document.querySelector(tocOutput).innerHTML += '<nav id="toc-nav-desktop" class="toc-nav">' + toc + '</nav>';
        document.querySelector(tocOutput).innerHTML += '<select id="contents-select" class="toc-nav">' + tocSel + '</select>';

        // If this is a content hub, then clone the element into the push nav
        let tocElement = document.querySelector(tocOutput);

        let tocClone = tocElement.cloneNode(true);
        let singleNav = document.querySelector('.ch-select-menu');

        window.singleNavDetect = singleNav;

        if (singleNav) {
            singleNav.appendChild(tocClone);
            window.dispatchEvent(new Event('resize'));
        }
    }
};

/**
 * Removes the unique span if the TOC is not enabled on a post
 */
window.removeUniqueSpan = function () {
    document.querySelectorAll(['.post-content-inner h1, .post-content-inner h2, .post-content-inner h3, .post-content-inner h4, .post-content-inner .panel .headings h2, .post-content-inner .panel .headings h3, .post-content-inner .panel .headings h4']).forEach((unique) => {
        unique = document.getElementsByClassName('bl-unique');

        while (unique.length > 0) {
            unique[0].parentNode.removeChild(unique[0]);
        }
    });
};

/** 
* Automatically create the accordion contents when the contents list is taller than the screen height
*/
window.contentsAccordion = function () {

    if (!window.contentsMobile(window.innerWidth)) {

        document.querySelectorAll('.toc-nav ul ul li').forEach((tocList) => {
            tocList.classList.add('toc-accordion');
        });

        document.querySelectorAll('.toc-accordion ul').forEach((tocListContent) => {
            tocListContent.classList.add('toc-accordion-content');
        });

        document.querySelectorAll('.toc-accordion ul li').forEach((tocListRemove) => {
            tocListRemove.classList.remove('toc-accordion');
        });

        document.querySelectorAll('.toc-accordion ul li ul').forEach((tocListRemove) => {
            tocListRemove.classList.remove('toc-accordion-content');
        });

        document.querySelectorAll('.bl-toc-list a').forEach((ariaSet) => {
            let innerText = ariaSet.textContent;
            ariaSet.innerHTML = innerText;
        });

        document.querySelectorAll('.toc-accordion .toc-link-acc').forEach((openSet) => {
            openSet.setAttribute('aria-expanded', 'false');
        });

        //  if the item has no children then hide the icon
        document.querySelectorAll('.toc-accordion').forEach((checkItem) => {
            if (checkItem.getElementsByTagName('UL').length > 0) {
                //  do nothing
            } else {
                //  hide the icon
                checkItem.classList.add('hide-icon');
            }
        });

        // const items = document.querySelectorAll(".toc-accordion a");
        const items = document.querySelectorAll(".toc-accordion div .open");

        function composedPath(el) {

            var path = [];

            while (el) {

                path.push(el);

                if (el.tagName === 'HTML') {

                    path.push(document);
                    path.push(window);

                    return path;
                }

                el = el.parentElement;
            }
        }

        /**
         * Toggle the accordion
         *
         * @param {array} item
         */
        function toggleAccordion(item) {

            let path = item.path || (item.composedPath && item.composedPath()) || composedPath(item.target);

            const itemSiblings = path[2].querySelectorAll('.toc-accordion-content');
            const itemToggle = this.parentNode.getAttribute('aria-expanded');

            this.classList.remove('active');

            document.querySelectorAll('.toc-accordion .toc-link-acc').forEach((close) => {
                close.setAttribute('aria-expanded', 'false');
            });

            document.querySelectorAll('.toc-accordion .toc-link-acc .open').forEach((open) => {
                open.classList.remove('active');
            });


            //  Only open/close the accordion if the items are top level.
            if (typeof (itemSiblings) !== 'undefined') {
                if (itemToggle == 'false') {

                    this.classList.add('active');
                    this.parentNode.setAttribute('aria-expanded', 'true');

                    let accContent = this.parentNode.parentNode.querySelector('.toc-accordion-content');
                    let accContentHeight = accContent.scrollHeight
                    adjustHeight(path, accContentHeight);

                } else {
                    this.parentNode.setAttribute('aria-expanded', 'false');
                    adjustHeight(path, 0);
                }
            }
        }

        items.forEach((item) => {

            item.addEventListener('click', toggleAccordion);

        });

        function adjustHeight(path, accContentHeight) {

            const accClass = '.ch-accordion';
            let checkAccordion = document.querySelector(accClass);
            let isContentHub = checkAccordion.dataset.accordion;

            if (isContentHub === 'true') {
                const navElement = document.querySelector('.bl-contents-container');
                window.doAccordion(accContentHeight)
            }

        }
    }
};

window.onReadyToc = function () {

    let toc = false;
    window.doHorizontalBreak();

    if (document.getElementById('toc')) {
        toc = true;
        let opt = null;

        window.tableOfContentsConstruct();
        window.contentsAccordion();
        window.doHorizontalBreak();

        zenscroll.setup(600, 80);

        let select = document.getElementById('contents-select');

        // add an option to the mobile contents
        if (window.singleNavDetect) {
            opt = new Option('Article Contents', 'first-option');
        } else {
            opt = new Option('Please select', 'first-option');
        }

        select.insertBefore(opt, select.firstChild);
        let setSelect = select.children[0];
        setSelect.setAttribute("selected", "selected");

    } else {
        window.removeUniqueSpan();
    }

    if (document.getElementById('no-toc')) {
        window.doHorizontalBreak();
    }

    // Do scroll to top

    let contentsScroll = document.querySelector('.contents-to-top');
    let contentsTopPos = document.querySelector('.bl-contents-container');

    if (contentsScroll) {
        contentsScroll.onclick = (e) => {
            e.preventDefault();
            zenscroll.to(contentsTopPos);
        }
    }

    /**
     * Observer for the contents nav 
     *
     * @param {function} fn
     */
    function contentsObserver(fn) {
        if (document.getElementById('toc')) {
            document.addEventListener('DOMContentLoaded', fn, false);

            window.addEventListener('resize', fn);
        }
    }

    contentsObserver(() => {
        const TableOfContents = {
            container: document.querySelector('.bl-toc-transparent'),
            links: null,
            headings: null,
            intersectionOptions: {
                rootMargin: "0px 0px -400px 0px",
                threshold: 1
            },
            previousSection: null,
            observer: null,

            /**
             * Initialise
             *
             */
            init() {
                this.handleObserver = this.handleObserver.bind(this);
                this.setUpObserver();
                this.findLinksAndHeadings();
                this.observeSections();
                this.mobileStatus();

                if (this.mobileStatus()) {
                    this.offsetVal = 100;
                } else {
                    this.offsetVal = 80;
                }

                window.addEventListener('hashchange', () => {
                    this.hashHandler(this.section);
                });

                if (this.mobileStatus()) {
                    this.contentsSelect = document.getElementById('contents-select');
                    this.contentsSelect.addEventListener('change', this.handleSelect.bind(this));
                }

                this.links.forEach((link) => {
                    if (!this.mobileStatus()) {
                        if (link) {
                            link.addEventListener('click', this.handleLinkClick.bind(this));
                        }
                    }
                });
            },
            /**
              * Checks if mobile
              *
              * @return {boolean} bool
              */
            mobileStatus() {

                if (window.innerWidth <= 800) {

                    return true;
                } else {
                    return false;
                }
            },

            /**
             * Handles the click event
             *
             * @param {event} evt
             */
            handleLinkClick(evt) {
                evt.preventDefault();

                let id = evt.target.getAttribute('href').replace('#', '');

                let section = this.headings.find((heading) => {
                    if (heading) {
                        return heading.getAttribute('id') === id;
                    }
                });

                zenscroll.to(section);

                if (this.container.classList.contains('is-active')) {
                    this.container.classList.remove('is-active');
                }

                history.replaceState(null, null, ' ');
            },

            handleSelect(evt) {
                evt.preventDefault();
                let id = evt.target.value;

                let section = this.headings.find((heading) => {
                    if (heading) {
                        return heading.getAttribute('id') === id;
                    }
                });

                zenscroll.to(section);

                if (this.container.classList.contains('is-active')) {
                    this.container.classList.remove('is-active');
                }

                history.replaceState(null, null, ' ');


            },

            /**
             * Handle the intersection observer
             *
             * @param {array} entries
             * @param {event} observer
             */
            handleObserver(entries, observer) {

                if (!this.mobileStatus()) {
                    entries.forEach((entry) => {

                        let href = `#${entry.target.getAttribute('id')}`;
                        let link = this.links.find((l) => l.getAttribute('href') === href);

                        if (entry.isIntersecting && entry.intersectionRatio >= 1) {

                            link.classList.add('is-visible');
                            this.previousSection = entry.target.getAttribute('id');
                        } else {

                            link.classList.remove('is-visible');
                        }

                        this.highlightFirstActive();
                    });
                }
            },

            /**
             * Highlights the first active link
             *
             */
            highlightFirstActive() {
                if (!this.mobileStatus()) {

                    let firstVisibleLink = this.container.querySelector('.is-visible');

                    this.links.forEach((link) => {
                        link.classList.remove('active');
                    });

                    if (firstVisibleLink) {

                        firstVisibleLink.classList.add('active');
                    }

                    if (!firstVisibleLink && this.previousSection) {
                        this.container.querySelector(`a[href="#${this.previousSection}"]`).classList.add('active');
                    }
                }
            },

            /**
             * Observe each section
             *
             */
            observeSections() {
                if (!this.mobileStatus()) {
                    this.headings.forEach((heading) => {
                        if (heading) {
                            this.observer.observe(heading);
                        }
                    });
                }
            },

            /**
             * Sets up the IntersectionObserver class
             *
             */
            setUpObserver() {
                if (!this.mobileStatus()) {
                    this.observer = new IntersectionObserver(
                        this.handleObserver,
                        this.intersectionOptions
                    );
                }


            },

            /**
             * Find the links and headings in the table of contents
             *
             */
            findLinksAndHeadings() {
                if (this.mobileStatus()) {
                    this.links = [...this.container.querySelectorAll('.toc-nav option')];
                    this.headings = this.links.map((link) => {
                        let id = '#' + link.value;
                        if (id !== "Contents") {
                            return document.querySelector(id);
                        }
                    });
                } else {

                    this.links = [...this.container.querySelectorAll('a')];

                    this.headings = this.links.map((link) => {
                        let id = link.getAttribute('href');
                        return document.querySelector(id);
                    });
                }
            },

            /**
             * Handles a weird jump when the hash changes
             *
             * @param {element} section
             */
            hashHandler(section) {
                history.replaceState(null, null, ' ');
            }
        };

        if (TableOfContents.container) {
            TableOfContents.init();

        }
    });

    // call the resize event - For the push nav
    window.dispatchEvent(new Event('resize'));
}

if (document.readyState == "interactive") {
    window.onReadyToc();
} else {
    document.addEventListener("DOMContentLoaded", window.onReadyToc);
}
